"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInvalidCreditError = void 0;

var _react = require("react");

var _identity = _interopRequireDefault(require("ramda/src/identity"));

var _mocks = require("../../../mocks");

var _constants = require("../../../constants");

var _utils = require("../../../utils");

var _services = require("../../../services");

/* eslint-disable react-hooks/exhaustive-deps */
const CreditErrorMessageByProduct = {
  [_constants.ProductTypes.AUTO]: {
    [_constants.ValidationTypes.MIN]: {
      title: 'Ops! Valor insuficiente',
      description: `Empréstimos com carro em garantia exigem valor minímo de ${(0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.AUTO].min, true)}`
    },
    [_constants.ValidationTypes.MAX]: {
      title: 'Ops! Valor excedido',
      description: `Valor máximo de ${(0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.AUTO].max, true)} para empréstimos com carro em garantia`
    }
  },
  [_constants.ProductTypes.HOME]: {
    [_constants.ValidationTypes.MIN]: {
      title: 'Ops! Valor insuficiente',
      description: `Empréstimos com imóvel em garantia exigem valor minímo de ${(0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.HOME].min, true)}`
    },
    [_constants.ValidationTypes.MAX]: {
      title: 'Ops! Valor excedido',
      description: `Valor máximo de ${(0, _utils.formatCurrency)(_mocks.CreditRangeByProduct[_constants.ProductTypes.HOME].max, true)} para empréstimos com imóvel em garantia`
    }
  }
};

const getValidationType = (value, productType) => {
  if (value < _mocks.CreditRangeByProduct[productType].min) {
    return _constants.ValidationTypes.MIN;
  }

  if (value > _mocks.CreditRangeByProduct[productType].max) {
    return _constants.ValidationTypes.MAX;
  }

  return null;
};

const errorEvents = {
  [_constants.ProductTypes.AUTO]: {
    [_constants.ValidationTypes.MIN]: _services.dispatchAutoInsufficientValueEvent,
    [_constants.ValidationTypes.MAX]: _services.dispatchAutoExceededValueEvent
  },
  [_constants.ProductTypes.HOME]: {
    [_constants.ValidationTypes.MIN]: _services.dispatchHomeInsufficientValueEvent,
    [_constants.ValidationTypes.MAX]: _services.dispatchHomeExceededValueEvent
  }
};

const useInvalidCreditError = (value, productType) => {
  const validationType = getValidationType(value, productType);
  const messages = CreditErrorMessageByProduct[productType][validationType];
  (0, _react.useEffect)(() => {
    const dispatchEvent = errorEvents[productType][validationType] || _identity.default;
    dispatchEvent();
  }, []);
  return {
    validationType,
    messages
  };
};

exports.useInvalidCreditError = useInvalidCreditError;